import { useCallback, useEffect, useState } from 'react';
import { sessionStorageService } from '@ibk/shared-utils';
const WELCOME_MODAL_DISMISSED_KEY = 'welcome-modal-dismissed';
export function useWelcomeModal(options = {}) {
    const { voucherContractId, hasActiveContract = false, checkHasRecharges, enabled = true } = options;
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [hasRecharges, setHasRecharges] = useState(null);
    const [isModalDismissed, setIsModalDismissed] = useState(false);
    useEffect(() => {
        const dismissed = sessionStorageService.getItemSync(WELCOME_MODAL_DISMISSED_KEY) ?? false;
        setIsModalDismissed(dismissed);
    }, []);
    const checkRecharges = useCallback(async () => {
        if (!enabled || !hasActiveContract || !voucherContractId || !checkHasRecharges) {
            return;
        }
        setIsLoading(true);
        setError(null);
        try {
            const hasAnyRecharges = await checkHasRecharges();
            setHasRecharges(hasAnyRecharges);
        }
        catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to check recharges';
            setError(errorMessage);
            console.error('Error checking recharges:', err);
        }
        finally {
            setIsLoading(false);
        }
    }, [enabled, hasActiveContract, voucherContractId, checkHasRecharges]);
    useEffect(() => {
        checkRecharges();
    }, [checkRecharges]);
    const dismissModal = useCallback(() => {
        setIsModalDismissed(true);
        sessionStorageService.setItemSync(WELCOME_MODAL_DISMISSED_KEY, true);
    }, []);
    const refresh = useCallback(() => {
        setHasRecharges(null);
        setError(null);
        checkRecharges();
    }, [checkRecharges]);
    const shouldShowModal = Boolean(enabled &&
        hasActiveContract &&
        !isModalDismissed &&
        hasRecharges === false &&
        !isLoading &&
        !error);
    return {
        shouldShowModal,
        isLoading,
        error,
        dismissModal,
        refresh,
        hasRecharges,
    };
}
